import React, { useState } from 'react';
import { IndicateurEtapes, LoaderMi, Container } from '@design-system-etat/dsfr-react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import CreerCompteChoixMotif from './components/motif/CreerCompteChoixMotif';
import CreerCompteIdentite from './components/identite/CreerCompteIdentite';
import CreerCompteEtapeValidation from './components/validation/CreerCompteEtapeValidation';
import CreerCompteAdresse from './components/adresse/CreerCompteAdresse';
import CreerCompteAdresseSecondaire from './components/adresseSecondaire/CreerCompteAdresseSecondaire';
import { definirComplement } from '../../../../store/titreReducer';

const CreerCompteEtape1 = ({
    featureFlipping,
    isLoadingFeatureFlipping,
    methodeDefinirComplement,
}) => {
    const [etape, setEtape] = useState('motif');

    const [motifs, setMotifs] = useState();
    const [identite, setIdentite] = useState();
    const [adressePrincipale, setAdressePrincipale] = useState();
    const [adressesSecondaires, setAdressesSecondaires] = useState([]);
    const [uuidBrouillon, setUuidBrouillon] = useState();
    const [isAncienLicencie, setIsAncienLicencie] = useState(false);

    const setMotifsSelectionnes = (motifsCoches) => {
        setMotifs({
            isChasseur: motifsCoches.isChasseur,
            isLicencie: motifsCoches.isLicencie,
            isNonLicencie: motifsCoches.isNonLicencie,
            isCollectionneur: motifsCoches.isCollectionneur,
            isDetenteurProfessionnel: motifsCoches.isDetenteurProfessionnel,
        });
        setUuidBrouillon(motifsCoches.uuidBrouillon);
        setEtape('identite');
    };

    const retourSelectionsMotifs = () => {
        setUuidBrouillon(null);
        setEtape('motif');
    };

    const setEtapeIdentite = (dataIdentite) => {
        setIdentite(dataIdentite);
        // Changer étape
        setEtape('adressePrincipale');
    };

    const setEtapeAdressePrincipale = (dataAdressePrincipale) => {
        setAdressePrincipale(dataAdressePrincipale);
        // Changer étape
        setEtape('adresseSecondaire');
    };

    const retourEtapeDeAdressesSecondaires = (dataAdressesSecondaires) => {
        setAdressesSecondaires(dataAdressesSecondaires);
        // Changer étape
        setEtape('adressePrincipale');
    };

    const setEtapeAdressesSecondaires = (dataAdressesSecondaires) => {
        setAdressesSecondaires(dataAdressesSecondaires);
        // Changer étape
        setEtape('validation');
    };

    const setEtapeValidation = () => {
        // Changer étape
        setEtape('validation-mail');
    };

    const setAncienLicencie = (ancienLicencie) => {
        setIsAncienLicencie(ancienLicencie);
    };

    const retourEtapeDeValidation = () => {
        // Changer étape
        setEtape('adresseSecondaire');
    };

    const etapes = [
        { id: 1, key: 'identite', titre: 'Identité' },
        {
            id: 2,
            key: 'adressePrincipale',
            titre: 'Adresse de la résidence principale et coordonnées',
        },
        {
            id: 3,
            key: 'adresseSecondaire',
            titre: 'Adresse(s) de résidence secondaire(s) en France',
        },
        { id: 4, key: 'validation', titre: 'Validation' },
    ];

    let etapeStepper = 0;

    if (etape === 'identite') {
        etapeStepper = 1;
    } else if (etape === 'adressePrincipale') {
        etapeStepper = 2;
    } else if (etape === 'adresseSecondaire') {
        etapeStepper = 3;
    } else if (etape === 'validation') {
        etapeStepper = 4;
    }

    React.useEffect(() => {
        if (etapeStepper > 0) {
            methodeDefinirComplement(`étape ${etapeStepper} sur 4`);
        }
    }, [etape, etapeStepper]);

    return (
        <>
            {isLoadingFeatureFlipping && <LoaderMi taille="md" />}
            {etape === 'motif' && featureFlipping && (
                <CreerCompteChoixMotif
                    motifsSelectionnes={motifs}
                    setMotifsSelectionnes={setMotifsSelectionnes}
                    featureFlipping={featureFlipping}
                />
            )}
            {uuidBrouillon && etape !== 'validation-mail' && (
                <Container>
                    <h1
                        aria-label="Création de compte - Première partie (1 sur 2)"
                        className="text-center"
                    >
                        Création de compte - Première partie (1/2)
                    </h1>
                    <IndicateurEtapes
                        etapeEnCours={etapeStepper}
                        nombreEtapes={4}
                        titreEtapeEnCours={etapes.find((step) => step.id === etapeStepper).titre}
                        titreProchaineEtape={
                            etapeStepper < 4
                                ? etapes.find((step) => step.id === etapeStepper + 1).titre
                                : null
                        }
                    />
                    {etape === 'identite' && (
                        <CreerCompteIdentite
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            dataIdentiteRenseignee={identite}
                            setEtapeIdentite={setEtapeIdentite}
                            retourEtape={retourSelectionsMotifs}
                            setAncienLicencie={setAncienLicencie}
                            featureFlipping={featureFlipping}
                        />
                    )}
                    {etape === 'adressePrincipale' && (
                        <CreerCompteAdresse
                            motifs={motifs}
                            uuidBrouillon={uuidBrouillon}
                            dataAdressePrincipaleRenseignee={adressePrincipale}
                            setEtapeAdresse={setEtapeAdressePrincipale}
                            retourEtape={() => setEtape('identite')}
                            isAncienLicencie={isAncienLicencie}
                        />
                    )}
                    {etape === 'adresseSecondaire' && (
                        <CreerCompteAdresseSecondaire
                            uuidBrouillon={uuidBrouillon}
                            dataAdressesSecondairesRenseignee={adressesSecondaires}
                            setEtapeAdresse={setEtapeAdressesSecondaires}
                            retourEtape={retourEtapeDeAdressesSecondaires}
                        />
                    )}
                    {etape === 'validation' && (
                        <CreerCompteEtapeValidation
                            setEtapeValidation={setEtapeValidation}
                            uuidBrouillon={uuidBrouillon}
                            retourEtape={retourEtapeDeValidation}
                        />
                    )}
                </Container>
            )}
            {uuidBrouillon && etape === 'validation-mail' && (
                <Container>
                    <h1>Finalisation de la création de votre compte</h1>
                    <div>
                        <p>
                            Pour finaliser la création de votre compte, veuillez cliquer sur le lien
                            du mail que vous venez de recevoir.
                        </p>
                        <p>
                            Si vous n'avez pas le mail dans votre boîte de réception, vérifiez que
                            ce message n'est pas dans votre dossier « spam » ou « courrier
                            indésirable ».
                        </p>
                        <p>
                            Si vous ne trouvez pas ce mail, veuillez prendre contact avec votre
                            préfecture via le formulaire de contact situé en bas de cet écran en
                            cliquant sur <strong>"Nous contacter"</strong>.
                        </p>
                    </div>
                </Container>
            )}
        </>
    );
};

CreerCompteEtape1.propTypes = {
    featureFlipping: PropTypes.object,
    isLoadingFeatureFlipping: PropTypes.bool,
    methodeDefinirComplement: PropTypes.func.isRequired,
};

export default connect(
    (state) => {
        const { data: featureFlipping, isLoading: isLoadingFeatureFlipping } =
            state.featureFlipping;
        return {
            featureFlipping,
            isLoadingFeatureFlipping,
        };
    },
    {
        methodeDefinirComplement: definirComplement,
    },
)(CreerCompteEtape1);
